module.exports = __webpack_public_path__ + "img/calendar-15.e47c7a17.svg";